var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.658,
    height: 37.65,
    viewBox: "0 0 37.658 37.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17482"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12523",
    d: "M-11630.35-3645.48v-4.874l.852-2.728 1.732-1.652h3.273l.979 1.652.774 1.612v5.46l-2.361.53h-5.249z",
    transform: "translate(11645.162 3682.155)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17324"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12519",
    d: "M12.358-511.946a4.017 4.017 0 0 0-2.879 2.871A39.37 39.37 0 0 0 9.371-504v4.6l-3.7 1.866c-2.04 1.02-3.848 1.953-4.014 2.061a3.949 3.949 0 0 0-1.432 2.206c-.1.391-.108 1.447-.094 8.5l.022 8.057.2.369a2.105 2.105 0 0 0 1.004 1.041l.456.246h33.633l.456-.246a2.105 2.105 0 0 0 1.013-1.049l.2-.369.022-8.057c.022-8.853.036-8.448-.42-9.374a3.671 3.671 0 0 0-1.23-1.41c-.231-.159-2.04-1.092-4.007-2.076l-3.588-1.787v-4.571c0-3.045-.029-4.709-.08-4.962a3.986 3.986 0 0 0-2.9-2.987c-.627-.141-11.954-.149-12.554-.004zm12.564 1.646a2.2 2.2 0 0 1 1.172 1.136l.239.485v32.114l-1.533.022-1.541.014v-2.546c0-2.922-.036-3.211-.514-4.181a4.7 4.7 0 0 0-3.031-2.416 5.478 5.478 0 0 0-2.17 0 4.691 4.691 0 0 0-3.031 2.416c-.477.976-.514 1.266-.514 4.181v2.546l-1.533-.014-1.541-.022v-32.114l.188-.4a2.205 2.205 0 0 1 .919-1.063c.644-.383.564-.376 6.741-.362l5.75.014zM9.371-487.094v10.56H5.856c-3.906 0-3.884 0-4.108-.47-.108-.224-.116-1.02-.1-8.079l.022-7.833.239-.485a2.246 2.246 0 0 1 .542-.738c.253-.2 6.7-3.5 6.871-3.508.027-.007.049 4.747.049 10.553zm21.923-8.9c3.624 1.823 3.747 1.9 4.108 2.669l.188.405.022 7.833c.014 7.059.007 7.855-.1 8.079-.224.47-.2.47-4.108.47h-3.517v-10.56c0-5.808.014-10.56.036-10.56s1.541.758 3.371 1.668zm-11.558 11.938a3.22 3.22 0 0 1 1.83 1.931 10.791 10.791 0 0 1 .137 2.987v2.568h-6.148l-.022-2.314c-.022-2.517.022-2.994.325-3.645a3.8 3.8 0 0 1 1.309-1.374 3.273 3.273 0 0 1 2.569-.153z",
    transform: "translate(.2 512.376)",
    style: {
      stroke: "#6f7e8e",
      strokeWidth: ".65px",
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12520",
    d: "M213.391-447.863a.918.918 0 0 0-.311.376 31.283 31.283 0 0 0-.08 3.371c0 3.493 0 3.522.47 3.739a1.106 1.106 0 0 0 .325.116 1.106 1.106 0 0 0 .325-.116c.405-.188.47-.434.47-1.794v-1.2h3.038v1.2c0 1.36.065 1.606.47 1.794a.542.542 0 0 0 .651 0c.47-.217.47-.239.47-3.747 0-3.472-.007-3.551-.427-3.761a.934.934 0 0 0-.369-.116.84.84 0 0 0-.694.47 5.1 5.1 0 0 0-.1 1.447v1.193h-3.038v-1.193c0-1.345-.065-1.62-.427-1.8a.687.687 0 0 0-.773.021z",
    transform: "translate(-197.281 452.958)",
    style: {
      fill: "#da5968"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12521",
    d: "M192.456-299.008a.844.844 0 0 0-.456.687.84.84 0 0 0 .47.694 75.96 75.96 0 0 0 8.318 0 .84.84 0 0 0 .47-.694.84.84 0 0 0-.47-.694 76.237 76.237 0 0 0-8.332.007z",
    transform: "translate(-177.8 314.852)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12522",
    d: "M192.456-235.008a.844.844 0 0 0-.456.687.84.84 0 0 0 .47.694 75.976 75.976 0 0 0 8.318 0 .84.84 0 0 0 .47-.694.84.84 0 0 0-.47-.694 76.237 76.237 0 0 0-8.332.007z",
    transform: "translate(-177.8 255.481)",
    style: {
      fill: "#6f7e8e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.518b0d89ef2bc7fac246874337e4008a.svg";
export { ForwardRef as ReactComponent };